import { RootState } from 'src/store/rootReducer'

export const getAnalysisList = ({
  AnalysisReducer,
}: RootState): UncDashboard.Analysis[] => {
  return AnalysisReducer.analysis || []
}
